import React, { useEffect, useState } from 'react'
import * as cookies from '../utilties/cookies'
import { injectIntl } from 'react-intl'
import { compose } from 'recompose'
import makeStyles from '@material-ui/core/styles/makeStyles'
import Header from '../components/Header'
import { Grid } from '@material-ui/core'
import PatientDetailHeader from '../components/PatientDetailHeader' 
import defaultBackground from '../assets/images/default-bg.png'
import { getTeamBackground, checkMFAState } from '../redux/actions'
import { teamBackgroundIsLoadingSelector, teamBackgroundSelector } from '../redux/selectors'
import { connect } from 'react-redux'
import TopHeader from './TopHeader'
import SurveySwitchHeader from './SurveySwitchHeader'

const useStyles = makeStyles((theme) => ({
    mainWrapper: {
        display: 'grid',
        minHeight: '100vh',
        paddingTop: '84px',
        [theme.breakpoints.down('sm')]: {
            paddingTop: '61px',
            minHeight: 'unset'
        },
        position: 'relative',
		minWidth: '320px',
		overflowX: 'hidden',
		display: 'flex',
		[theme.breakpoints.up('lg')]: {
			minWidth: '1200px',
		},
    },
    mainWrapperBackground: {
        backgroundColor: '#ededf1',
    },
    mainHeaderWrapper: {
        height: '84px',
        backgroundColor: 'white',
        flexWrap: 'nowrap',
        borderBottom: '1px #171821 solid',
        [theme.breakpoints.down('sm')]: {
            height: '61px',
        },
    },
    mainContent: {
        position: 'relative',
        minHeight: 'calc(100vh - 84px)',
        [theme.breakpoints.down('sm')]: {
            minHeight: 'calc(100vh - 61px)',
            maxHeight: 'calc(100vh - 61px)',
        },
		maxHeight: 'calc(100vh - 84px)',
		overflowX: 'hidden',
		flexGrow: '100',
		minWidth: '320px',
		zIndex: '2',
		'WebkitOverflowScrolling': 'touch',
    },
    mainHeader: {
        height: '84px',
        backgroundColor: 'white',
        padding: '0 32px',
        position: 'fixed',
        top: '0',
        left: '0',
        right: '0',
        width: '100%',
        zIndex: '111',
        flexWrap: 'nowrap',
        [theme.breakpoints.down('sm')]: {
            height: '61px',
            backgroundColor: 'white',
            padding: '0 16px',
        },
    },
    mainHeaderBarOuter: {
        minHeight: '55px',
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        backgroundColor: '#fff',
        width: '100%',
        margin: '0 auto',
        [theme.breakpoints.down('sm')]: {
            height: 'auto',
            minHeight: 'unset'
        },
    },
    mainHeaderBar: {
        padding: '0 32px',
        minHeight: '55px',
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        maxWidth: '1400px',
        margin: '0 auto',
        [theme.breakpoints.down('sm')]: {
            padding: '0 16px',
            height: 'auto',
            minHeight: 'unset'
        },
    },
    surveySwitchHeaderBarBackgroud: {
        backgroundColor: '#111',
    },
    mainHeaderLogo: {
        padding: '10px 20px 10px 0',
        borderRight: '1px solid #EEF1F9',
        display: 'flex',
        maxWidth: '200px',
        height: '100%',
        [theme.breakpoints.down('sm')]: {
            maxWidth: '100px',
            paddingLeft: '20px'
        },
    },
    passportTitle: {
        fontSize: '24px',
        fontWeight: '600',
        [theme.breakpoints.down('sm')]: {
            fontSize: '16px',
        },
    },

    mainBgImage: {
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        position: 'absolute',
        left: 0,
        width: '100%',
        height: '320px',
        backgroundColor: '#171821',
        [theme.breakpoints.down('sm')]: {
            height: '160px',
        },
        "&::before": {
            display: 'block',
            content: `''`,
            position: 'absolute',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            background: 'rgba(0,0,0,0.4)',
        }
    }

}));
  

const StyledWrapper = ({
    intl,
    children,
    logoUrl,
    backgroundUrl,
    teamBackground,
    checkMFAState,
    loadTeamBackground,
    teamBackgroundIsLoading,
    hideMenu,
    hidePagesMenu,
    onSkipSurveySwitcherClick,
    hideSurveySwitcher = true,
    canChangeLanguage = true,
    canChangePassword = true,
    showBackground = true,
    ...other
}) => {
    const classes = useStyles();
    const [ patient ] = useState(cookies.get('user'))

    useEffect(() => {
        if(!patient.externalAuth) {
            checkMFAState()
        }
        
		loadTeamBackground()
	}, [])

    return (
        <div data-testid="page-wrapper" className={`${classes.mainWrapper} mainPatientWrapper ${showBackground ? classes.mainWrapperBackground : ''}`}>
            <div data-testid="header" className={classes.mainHeaderWrapper} >
                <Header
                    data-testid="page-header"
                    hideMenu={hideMenu}
                    hidePagesMenu={hidePagesMenu}
                    isExternalAuth={patient.externalAuth}
                    canChangeLanguage={canChangeLanguage}
                    canChangePassword={canChangePassword}
                />
            </div>

            <div id="styled-wrapper-main-content" data-testid="main-content" className={`${classes.mainContent} main-content`}>
                {
                    !(hideMenu || hidePagesMenu) &&
                    <div>
                        <div className={classes.mainHeaderBarOuter} style={{borderBottom: showBackground ? '' : '1px solid'}}>
                            <Grid
                                container
                                direction="column"
                                spacing={0}
                            >
                                {
                                    !hideSurveySwitcher
                                    && <Grid
                                        data-testid="header-survey-switch"
                                        className={classes.surveySwitchHeaderBarBackgroud}
                                    >
                                        <div
                                            data-testid="header-survey-switch"
                                            className={classes.mainHeaderBar}
                                        >
                                            <SurveySwitchHeader onSkipClick={onSkipSurveySwitcherClick} />
                                        </div>
                                    </Grid>
                                }
                                <Grid className={classes.mainHeaderBar} data-testid="header-patient-detail">
                                    <PatientDetailHeader />
                                </Grid>
                            </Grid>
                           {
                                //<Grid item style={{ width: '100%' }}>
                                //    <TopHeader />
                                //</Grid>
}
                        </div>
                    </div>
                }
                {showBackground && <div data-testid="main-content-bg-img" data-print="none"
                    className={classes.mainBgImage}
                    style={{
                        backgroundImage: `url(${(backgroundUrl || teamBackground || !teamBackgroundIsLoading && defaultBackground)})`
                    }}>
                </div>}
                <div data-testid="main-content-inner" className="patient-main-content-inner"
                    style={{
                        position: 'relative',
                        minHeight: '100%'
                    }}>
                    {children}
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({
	teamBackground: teamBackgroundSelector(state),
	teamBackgroundIsLoading: teamBackgroundIsLoadingSelector(state)
})

const mapDispatchToProps = (dispatch) => ({
    checkMFAState: () => dispatch(checkMFAState()),
	loadTeamBackground: () => dispatch(getTeamBackground())
})

const enhance = compose(connect(mapStateToProps, mapDispatchToProps), injectIntl)

export default enhance(StyledWrapper)
